import { ready, onceInitialized } from '../../lib/lifecycle/ready';

function toggleFlipCard(card) {
  card.classList.toggle('is-flipped');
  card.setAttribute('aria-pressed', card.classList.contains('is-flipped') ? 'true' : 'false');
}

function initFlipCards(root) {
  const scope = root || document;
  scope.querySelectorAll('.wp-block-modulr-flip-card').forEach((card) => {
    if (!onceInitialized(card, 'flip-card')) return;

    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-pressed', card.classList.contains('is-flipped') ? 'true' : 'false');

    card.addEventListener('click', () => {
      toggleFlipCard(card);
    });

    card.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleFlipCard(card);
      }
    });
  });
}

ready(initFlipCards, { scope: 'modulr-flip-card' });
